<template>
    <div
        v-if="activeChatTemplatesTab"
        id="active-chat-templates"
        :class="{ show: activeChatTemplatesTab }"
        class="mx-1"
    >
        <b-tabs v-model="activeTabIndex" class="p-2" lazy pills>
            <span class="close-icon">
                <font-awesome-icon icon="times" @click="activeChatTemplatesTab = ''" />
            </span>

            <b-tab :active="activeTabIndex === 0" :disabled="!customerCareWindow">
                <template #title>
                    <font-awesome-icon icon="slash-forward" />
                    {{ $t("entities.quick-replies.Quick replies") }}
                </template>

                <quick-replies />
            </b-tab>
            <b-tab
                v-if="templatePlatforms.includes(channelsStore.activeChatChannel.platform)"
                :active="activeTabIndex === 1"
            >
                <template #title>
                    <font-awesome-icon :icon="['fab', 'whatsapp']" />
                    {{ $t("platforms.whatsapp") }} {{ $t("entities.templates.approved-templates") }}
                </template>

                <approved />
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import {
    BAlert,
    BAvatar,
    BBadge,
    BCard,
    BCardText,
    BListGroup,
    BListGroupItem,
    BNav,
    BNavItem,
    BTab,
    BTabs,
} from "bootstrap-vue";

import QuickReplies from "@/views/modules/messaging-inbox/templates/quickReplies";
import Approved from "@/views/modules/messaging-inbox/templates/approved";
import Variables from "@/views/modules/messaging-inbox/templates/variables";
import { resolveRemainingCustomerCareWindow } from "@/utils/chats";
import { computed, defineComponent } from "@vue/composition-api";
import useTemplates from "@/composables/v3/useTemplates";
import { useChannelsStore } from "@/store/useChannelsStore";
import { useChatsStore } from "@/store/useChatsStore";

export default defineComponent({
    components: {
        Approved,
        BAlert,
        BAvatar,
        BBadge,
        BCard,
        BCardText,
        BListGroup,
        BListGroupItem,
        BNav,
        BNavItem,
        BTab,
        BTabs,
        QuickReplies,
        Variables,
    },
    setup() {
        const channelsStore = useChannelsStore();
        const chatsStore = useChatsStore();
        const { activeTabIndex, activeChatTemplatesTab } = useTemplates();
        const templatePlatforms = ["whatsapp", "test"];

        const customerCareWindow = computed(() =>
            resolveRemainingCustomerCareWindow(
                chatsStore.activeChat?.chat.lastInboundMessageTime,
                channelsStore.activeChatChannel.customerCareWindowLength
            )
        );

        return {
            activeTabIndex,
            templatePlatforms,
            customerCareWindow,
            activeChatTemplatesTab,
            channelsStore,
        };
    },
});
</script>

<style lang="scss">
@import "~@/assets/scss/components/inbox/activeChatTemplates.scss";
</style>
